/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface ISpeedTestResult {
        hostResults: ISpeedTestHostResult[];
        totalSamples: number[];
        totalAverage: number;
        errorMessage?: string;
    }

    export interface ISpeedTestHostResult {
        average: number;
        name: string;
        host: string;
        cc: string;
        country: string;
        bandwithSamples: number[];
    }

    export interface ITestResult {
        result: string;
        error: string;
    }

}